import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";

import Loader from 'components/Loader';
import SectionShow from './sections/show';
import NeighborhoodData from './sections/neighborhood-data';
import PatientsIndex from './sections/patients/index';
import PatientNew from './sections/patients/new';
import PatientEdit from './sections/patients/edit';
import RoomShow from './sections/rooms/show';
const thresholdsJSON = require('../../util/thresholds.json');
import Api from "../../util/Api";

// Workaround to have access to the section info in RoomShow. we could
// refactor the routes to be nested and pass down the resources
class RoomShowContainer extends Component {
    componentDidMount() {
    //bd for a specific section
        const {match} = this.props;
        const sectionDetails = {
            sectionName: match.params.section
        };

        this.props.auth.onSectionDetails(sectionDetails);
        this.setState({sectionDetails});
    }

    render(){
        return <RoomShow
            {...this.props}
            {...this.state}
        />;
    }
}

class FacilityShow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            sections: {},
            selectedSection: '',
            listeners: [],
        };
        this.handleSectionChange = this.handleSectionChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // console.log({'facilityUpdate': this.props});
            this.props.history.go();
        }
    }
    handleSectionChange(section){
        this.setState({selectedSection: section});
    }
    componentDidMount() {
        const {match} = this.props;

        // console.log(this.props);
        this.setState({
            isLoading: false,
            thresholds:thresholdsJSON
        });

        this.props.auth.onOrganizationDetails(this.props.auth.currentUser.defaultOrg);
        const facilityDetails = {
            facilityName: match.params.facility,
            thresholds: thresholdsJSON,
        };

        this.props.auth.onFacilityDetails(facilityDetails);


        const sectionDetails = {};
        sectionDetails.sectionName = this.props.auth.currentUser.defaultSection;

        this.props.auth.onSectionDetails(sectionDetails);

        Api.withAuth(this.props.auth)
            .getSections(facilityDetails.facilityName)
            .then((response) => {
                // console.log(response);
                this.setState({sections: response});
            });
    }
    render() {
        const {auth} = this.props;
        // console.log({'facilityProps:': this.props});
        return (
            <React.Fragment>
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        {this.state.sectionCount === 0 ? (
                            <div className='alert alert-info'>Facility has no sections</div>
                        ) : (
                            <Switch>
                                <Route path={`/facilities/:facility/sections/:section/rooms`} exact render={(props) => (
                                    <SectionShow
                                        auth={auth}
                                        {...props}
                                        sections={this.state.sections}
                                        onSectionChange={this.handleSectionChange}
                                    />
                                )} />
                                <Route path={`/facilities/:facility/sections/:section/patients`} exact render={(props) => (
                                    <PatientsIndex
                                        auth={auth}
                                        {...props} />
                                )} />
                                <Route path={`/facilities/:facility/sections/:section/patients/new`} exact render={(props) => (
                                    <PatientNew
                                        auth={auth}
                                        {...props} />
                                )} />
                                <Route path={`/facilities/:facility/sections/:section/patients/:id/edit`} exact render={(props) => (
                                    <PatientEdit
                                        auth={auth}
                                        {...props} />
                                )} />
                                <Route path={`/facilities/:facility/sections/:section/neighborhood-data`} exact render={(props) => (
                                    <NeighborhoodData
                                        auth={auth}
                                        {...props}
                                    />
                                )} />
                                <Route path={`/facilities/:facility/sections/:section/rooms/:room/patient/:patientid`} exact render={(props) => (
                                    <RoomShowContainer
                                        auth={auth}
                                        {...props}
                                    />
                                )} />
                            </Switch>
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default FacilityShow;
